import imgLoad from "@/components/imgLoad";
import imgsUpload from "@/components/imgsUpload";
import baseUpload from "@/components/baseUpload";
import DecryptImg from "@/components/decrypt-img/index.vue";
import multiplePreviewPicture from "@/components/multiplePreviewPicture";
// import globalUploader from '@/components/globalUploader

import cropper from "@/components/cropper";
import addFormItem from "@/components/AddFormItem";
export default (Vue) => {
  Vue.component("ImgLoad", imgLoad);
  Vue.component("ImgsUpload", imgsUpload);
  Vue.component("BaseUpload", baseUpload);
  Vue.component("Cropper", cropper);
  Vue.component("AddFormItem", addFormItem);
  Vue.component("DecryptImg", DecryptImg);
  Vue.component("MultiplePreviewPicture", multiplePreviewPicture);
  // Vue.component('GlobalUploader', globalUploader)
};
